import { MqttContainer, MqttValue, instanceOfMqttValue } from './types'
import mqttDefinitions from './bikefitting'
// import { MqttClient } from 'mqtt'

/* Creates the topic by combining an array of definitions for MqttContainers and an MqttValue
 * e.g.: createTopicFromValuesArrays([mqttDefinitions, cranksetDefinitions, cranksetPower]);
 * @returns topic in string format
 */
export function createTopicFromValuesArrays(
  definitions: (MqttContainer | MqttValue)[],
): string {
  const defs = [...definitions]
  // if the root is not present add it
  if (
    instanceOfMqttValue(defs[0]) ||
    defs[0].prefix !== mqttDefinitions.prefix
  ) {
    defs.unshift(mqttDefinitions)
  }

  const topic = defs.reduce((topicAccumulator, currentValue) => {
    if (instanceOfMqttValue(currentValue)) {
      return topicAccumulator + currentValue.topic
    }
    return topicAccumulator + currentValue.prefix
  }, '')
  return topic
}

export type ConversionDirection = 'submit' | 'receive'

export function mqttValueConversion(
  value: number | object | undefined,
  conversionValue: number | undefined,
  direction: ConversionDirection,
) {
  const conv = conversionValue || 1
  let returnValue
  if (value && typeof value === 'number' && value > 0) {
    returnValue = direction === 'submit' ? value / conv : value * conv
  } else {
    returnValue = 0
  }
  return Math.round(returnValue)
}
